import { useCallback, useEffect } from "react";

import { useLocation } from "react-router-dom";

import { useFireAnalyticsEvents } from "@/analytics";
import {
    SourceKey,
    ActionKey,
    ActionSubjectKey,
    ActionSubjectIdKey
} from "@/analytics/constants";
import { useFastshiftSelector } from "@/state";

export const use404DisplayAnalytics = () => {
    const location = useLocation();
    const { fireScreenEvent, fireUIEvent } = useFireAnalyticsEvents();

    const { data: userDetails } = useFastshiftSelector(
        (state) => state.userDetails
    );

    // Screen event - when 404 page is displayed
    useEffect(() => {
        if (!userDetails) return;

        fireScreenEvent({
            name: SourceKey.FASTSHIFT_PORTAL_404_SCREEN,
            attributes: {
                userDomain: userDetails.userDomain.domain,
                pageRoute: location.pathname
            }
        });
    }, [fireScreenEvent, userDetails, location.pathname]);

    // UI event callback for home link click
    const sendGoBackToHomeLinkClickUIEvent = useCallback(() => {
        if (!userDetails) return;

        fireUIEvent({
            action: ActionKey.CLICKED,
            actionSubject: ActionSubjectKey.LINK,
            actionSubjectId: ActionSubjectIdKey.GO_BACK_TO_HOME_LINK,
            source: SourceKey.FASTSHIFT_PORTAL_404_SCREEN,
            attributes: {
                userDomain: userDetails.userDomain.domain,
                pageRoute: location.pathname
            }
        });
    }, [fireUIEvent, userDetails, location.pathname]);

    return {
        sendGoBackToHomeLinkClickUIEvent
    };
};
